








import {Component, Vue} from 'vue-property-decorator';
import Multiselect from "vue-multiselect"

@Component({
    components: {Multiselect}
})
export default class JdsRichDropdown extends Vue {
    value = '';
    options = ['a', 'b', 'c'];
}
